export const initProducts = function (config) {
  if ($('.flixx_products').length === 0) {
    return;
  }

  /**
   * Extract filter values from the given form and return them as a key-value object.
   * Only fields with non-empty values are included.
   * @param {jQuery} $form
   * @returns {Object}
   */
  function getFilterValues($form) {
    const values = {};

    $form.find('input, select').each(function () {
      const name = $(this).attr('name');
      const value = $(this).val();

      if (value === '') {
        return;
      }

      const base = 'tx_flixxconfigwandfluh_products';
      if (!name.startsWith(base)) {
        return;
      }

      const relative = name.replace(`${base}[`, '').replace(/\]$/g, '');
      const keys = relative.split('][');

      let current = values;
      for (let i = 0; i < keys.length - 1; i++) {
        if (!current[keys[i]]) {
          current[keys[i]] = {};
        }
        current = current[keys[i]];
      }

      current[keys[keys.length - 1]] = value;
    });

    return values;
  }

  // Add hidden field for filters_json if not present
  $('section.flixx_products form').append('<input type="hidden" name="filters_json" />');

  /**
   * Show or hide the "more" link based on current result count.
   */
  function toggleMoreLinkVisibility($section) {
    const $table = $section.find('table');
    const $tableBody = $table.find('tbody');
    const $moreLink = $section.find('.loadmore:not(.btn)');

    const totalCount = parseInt($table.attr('data-total') || 0);
    const rowCount = $tableBody.find('tr:visible').length;

    if (rowCount < totalCount) {
      $moreLink.show();
    } else {
      $moreLink.hide();
    }
  }

  /**
   * Load additional product rows via AJAX based on filters_json.
   */
  function loadProductsAsyncByFilter($trigger) {
    const $section = $trigger.closest('section');
    const $form = $section.find('form');
    const $tableBody = $section.find('table tbody');
    const isLink = $trigger.is('a');

    let offset = 0;
    let requestUrl = isLink ? $trigger.attr('href') : $form.attr('action');

    if (isLink) {
      offset = $tableBody.find('tr').length;
    } else {
      $tableBody.empty();
    }

    requestUrl += (requestUrl.includes('?') ? '&' : '?') + 'offset=' + offset;

    let parameter = {};
    try {
      parameter = JSON.parse($form.find('input[name="filters_json"]').val() || '{}');
    } catch (e) {
      console.warn('Invalid JSON in filters_json');
    }

    $section.find('.row.loading').removeClass('d-none');
    $section.find('.row.no-results').addClass('d-none');
    $section.find('table').addClass('d-none');

    $.ajax({
      url: requestUrl,
      method: 'POST',
      data: parameter,
      success: function (response) {
        $tableBody.append($(response).find('tr'));

        // Update data-total from response table if available
        const responseTable = $('<div>').html(response).find('table');
        const responseTotal = responseTable.data('total');
        if (typeof responseTotal !== 'undefined') {
          $tableBody.closest('table').attr('data-total', responseTotal);
        }

        const updatedCount = $tableBody.find('tr').length;
        const total = parseInt($tableBody.closest('table').attr('data-total') || 0);

        const $tableWrapper = $section.find('table');
        const $noResultsRow = $section.find('.row.no-results');

        if (updatedCount > 0) {
          $tableWrapper.removeClass('d-none');
          $noResultsRow.addClass('d-none');
        } else {
          $tableWrapper.addClass('d-none');
          $noResultsRow.removeClass('d-none');
        }
      },
      complete: function () {
        $section.find('.row.loading').addClass('d-none');

        if (isLink) {
          const updatedCount = $tableBody.find('tr').length;
          $trigger.attr('data-offset', updatedCount);
        }

        console.log('Updated rows:', $tableBody.find('tr').length);
        console.log('Total expected:', $tableBody.closest('table').attr('data-total'));

        toggleMoreLinkVisibility($section);
      }
    });
  }

  // Button: generate filters_json and load
  $('section.flixx_products .loadmore.btn').on('click', function (e) {
    e.preventDefault();

    const $section = $(this).closest('section');
    const $form = $section.find('form');

    const parameter = getFilterValues($form);
    $form.find('input[name="filters_json"]').val(JSON.stringify(parameter));

    loadProductsAsyncByFilter($(this));
  });

  // Link: just load
  $('section.flixx_products .loadmore:not(.btn)').on('click', function (e) {
    e.preventDefault();
    loadProductsAsyncByFilter($(this));
  });

  /**
   * Handle category link clicks from the sidebar filter.
   * Update the hidden 'categories' input in the form and toggle active class.
   */
  $('section.flixx_products .filter.left .list-group-item a').on('click', function (e) {
    e.preventDefault();

    const $categoryLink = $(this);
    const categoryValue = $categoryLink.attr('href').replace(/^#/, '').trim();
    const $section = $categoryLink.closest('section');
    const $form = $section.find('form');

    $form.find('input[name$="[categories]"]').val(categoryValue);
    $categoryLink.closest('.list-group').find('a').removeClass('active');
    $categoryLink.addClass('active');

    const $loadMore = $section.find('.loadmore');
    const tableTotal = parseInt($section.find('table').data('total') || 0);
  });

  /**
   * Reset all product filters in the form and sidebar.
   */
  $('section.flixx_products .reset-filters').on('click', function (e) {
    e.preventDefault();

    const $section = $(this).closest('section');
    const $form = $section.find('form');

    // Reset all select fields
    $form.find('select.form-select').each(function () {
      $(this).val('');
      $(this).trigger('change');
    });

    // Reset hidden category field
    $form.find('input[name$="[categories]"]').val('');

    // Remove active class from sidebar links
    $section.find('.filter.left .list-group-item a').removeClass('active');

    // Optional: clear result table and reset offset
    $section.find('table tbody').empty();
    $section.find('.loadmore').attr('data-offset', 0);

    const $loadMore = $section.find('.loadmore');
    const tableTotal = parseInt($section.find('table').data('total') || 0);
  });

// warte minimal, bis Click-Handler sicher aktiv ist
  setTimeout(function () {
    $('section.flixx_products:not(.product-type-chapter) .loadmore').first().trigger('click');

    //Chapter
    $('section.flixx_products .form-select.chapter').on('change', function () {
      const $select = $(this);
      $select.find('option[value=""]').remove();

      const $section = $(this).closest('section');
      $section.find('.loadmore.btn.d-none').trigger('click');
    });
    $('section.flixx_products.product-type-chapter a.loadmore').hide();
    $('section.flixx_products.product-type-chapter').find('table').addClass('d-none')
  }, 0);
};

// Hinweis: In Fluid müssen die folgenden Zeilen ergänzt werden:
// <div class="row loading d-none">...</div>
// <div class="row no-results d-none">Keine Ergebnisse</div>
